import { AuthLayout } from "@/layouts/auth-layout";
import React from "react";
import { useRouter } from "next/navigation";
import { resetPassword } from "@/firebase/firebaseAuth";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useTranslations } from "next-intl";
import { getAuthErrorMessage } from "@/lib/authErrors";
function isNoAccountError(error: unknown): boolean {
  const code = String((error as {
    code?: string;
  } | null | undefined)?.code || "").toLowerCase();
  return code === "auth/user-not-found";
}
export default function ResetPassword() {
  const router = useRouter();
  const t = useTranslations();
  const [email, setEmail] = React.useState('');
  const [errorMessage, setErrorMessage] = React.useState('');
  const [successMessage, setSuccessMessage] = React.useState('');
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const handleForm = async (event: React.FormEvent) => {
    event.preventDefault();
    setIsSubmitting(true);
    setErrorMessage('');
    setSuccessMessage('');
    try {
      await resetPassword(email);
      setSuccessMessage(t('requestPasswordReset.success'));
      setTimeout(() => {
        router.push('/login');
      }, 2000);
    } catch (error: unknown) {
      if (isNoAccountError(error)) {
        setErrorMessage(t('requestPasswordReset.noAccount'));
      } else {
        setErrorMessage(getAuthErrorMessage((error as {
          code?: string;
        } | null | undefined)?.code, t, 'errors.invalidEmail'));
      }
    } finally {
      setIsSubmitting(false);
    }
  };
  return <AuthLayout title={t('requestPasswordReset.title')} data-sentry-element="AuthLayout" data-sentry-component="ResetPassword" data-sentry-source-file="resetPassword.tsx">
            <Form onSubmit={handleForm} data-sentry-element="Form" data-sentry-source-file="resetPassword.tsx">
                <Row className="g-5" data-sentry-element="Row" data-sentry-source-file="resetPassword.tsx">
                    <Form.Group controlId="email" data-sentry-element="unknown" data-sentry-source-file="resetPassword.tsx">
                        <Form.Control type="email" onChange={e => setEmail(e.target.value)} placeholder={t('requestPasswordReset.emailPlaceholder')} required data-sentry-element="unknown" data-sentry-source-file="resetPassword.tsx" />
                    </Form.Group>
                    {errorMessage || successMessage ? <Col xs={12}>
                            {errorMessage && <p className="text-danger text-sm mb-0">{errorMessage}</p>}
                            {successMessage && <p className="text-success text-sm mb-0">{successMessage}</p>}
                        </Col> : null}
                    <Form.Group data-sentry-element="unknown" data-sentry-source-file="resetPassword.tsx">
                        <Button type="submit" className="btn btn-primary w-100" disabled={isSubmitting} data-sentry-element="Button" data-sentry-source-file="resetPassword.tsx">
                            {t('requestPasswordReset.submit')}
                        </Button>
                    </Form.Group>
                </Row>
            </Form>
        </AuthLayout>;
}